import styled from "styled-components";

export const UserCardsSc = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .user-detail-card {
    color: white;
    padding: 10px 15px;
    transition: all 1.1s;
  }
  .user-detail-card:hover {
    box-shadow: 0 10px 20px 0 pink;
    scale: 1;
  }
`;
